/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __awaiter, __extends, __generator } from "tslib";
import * as runtime from '../runtime';
import { PagedResponseOfTagListEntryFromJSON, TagRequestToJSON, TagResponseFromJSON, } from '../models';
/**
 *
 */
var TagRestControllerApi = /** @class */ (function (_super) {
    __extends(TagRestControllerApi, _super);
    function TagRestControllerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a new tag  \'Permission#CREATE_TAG\' is required to access to this endpoint
     * Create a new tag  \'Permission#CREATE_TAG\' is required to access to this endpoint
     */
    TagRestControllerApi.prototype.createTagRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.tagRequest === null || requestParameters.tagRequest === undefined) {
                            throw new runtime.RequiredError('tagRequest', 'Required parameter requestParameters.tagRequest was null or undefined when calling createTag.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/tags",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: TagRequestToJSON(requestParameters.tagRequest)
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return TagResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create a new tag  \'Permission#CREATE_TAG\' is required to access to this endpoint
     * Create a new tag  \'Permission#CREATE_TAG\' is required to access to this endpoint
     */
    TagRestControllerApi.prototype.createTag = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createTagRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete tag  \'Permission#DELETE_TAG\' is required to access to this endpoint
     * Delete tag  \'Permission#DELETE_TAG\' is required to access to this endpoint
     */
    TagRestControllerApi.prototype.deleteTagRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.tagId === null || requestParameters.tagId === undefined) {
                            throw new runtime.RequiredError('tagId', 'Required parameter requestParameters.tagId was null or undefined when calling deleteTag.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/tags/{tagId}".replace("{".concat("tagId", "}"), encodeURIComponent(String(requestParameters.tagId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete tag  \'Permission#DELETE_TAG\' is required to access to this endpoint
     * Delete tag  \'Permission#DELETE_TAG\' is required to access to this endpoint
     */
    TagRestControllerApi.prototype.deleteTag = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteTagRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get tag details  \'Permission#READ_TAG\' is required to access to this endpoint
     * Get tag details  \'Permission#READ_TAG\' is required to access to this endpoint
     */
    TagRestControllerApi.prototype.getTagRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.tagId === null || requestParameters.tagId === undefined) {
                            throw new runtime.RequiredError('tagId', 'Required parameter requestParameters.tagId was null or undefined when calling getTag.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/tags/{tagId}".replace("{".concat("tagId", "}"), encodeURIComponent(String(requestParameters.tagId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return TagResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get tag details  \'Permission#READ_TAG\' is required to access to this endpoint
     * Get tag details  \'Permission#READ_TAG\' is required to access to this endpoint
     */
    TagRestControllerApi.prototype.getTag = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getTagRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * List tags using pagination  \'Permission#READ_TAG\' is required to access to this endpoint
     * List tags using pagination  \'Permission#READ_TAG\' is required to access to this endpoint
     */
    TagRestControllerApi.prototype.listTagsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.size !== undefined) {
                            queryParameters['size'] = requestParameters.size;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/tags",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return PagedResponseOfTagListEntryFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * List tags using pagination  \'Permission#READ_TAG\' is required to access to this endpoint
     * List tags using pagination  \'Permission#READ_TAG\' is required to access to this endpoint
     */
    TagRestControllerApi.prototype.listTags = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listTagsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update tag  \'Permission#UPDATE_TAG\' is required to access to this endpoint
     * Update tag  \'Permission#UPDATE_TAG\' is required to access to this endpoint
     */
    TagRestControllerApi.prototype.updateTagRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.tagId === null || requestParameters.tagId === undefined) {
                            throw new runtime.RequiredError('tagId', 'Required parameter requestParameters.tagId was null or undefined when calling updateTag.');
                        }
                        if (requestParameters.tagRequest === null || requestParameters.tagRequest === undefined) {
                            throw new runtime.RequiredError('tagRequest', 'Required parameter requestParameters.tagRequest was null or undefined when calling updateTag.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("keycloak", [])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/tags/{tagId}".replace("{".concat("tagId", "}"), encodeURIComponent(String(requestParameters.tagId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: TagRequestToJSON(requestParameters.tagRequest)
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return TagResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update tag  \'Permission#UPDATE_TAG\' is required to access to this endpoint
     * Update tag  \'Permission#UPDATE_TAG\' is required to access to this endpoint
     */
    TagRestControllerApi.prototype.updateTag = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateTagRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return TagRestControllerApi;
}(runtime.BaseAPI));
export { TagRestControllerApi };
